import { Meter  } from "../../classes";

const MeterModule = {
  namespaced: true,
  state: {
    meter: [],
    meterSettings: [],
    meters: []
  },
  actions: {
    getMeterByArea: async ({ commit }, payload) => {
      try {
        const data = await Meter.getMeterByArea({
          areaId: payload.areaId
        });
        commit("setMeter", { meter: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    getMeterByAreas: async ({ commit }, payload) => {
      try {
        const data = await Meter.getMeterByAreas({
          areaIds: payload.areaIds
        });
        commit("setMeter", { meter: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    getMeterByMarket: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await Meter.getMeterByMarket(
          payload.marketId,
          payload.type
        );
        commit("setMeterSetting", { meter: data });
        //
        return data;
      } catch (err) {
        return false;
      }
    },
    createMeter: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await Meter.createMeter(payload);
        // dispatch("getMeterByArea", { areaId: data?.area.objectId });
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateMeter: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await Meter.updateMeter(payload);
        // dispatch("getMeterByArea", { areaId: data?.area.objectId });
        return data;
      } catch (err) {
        throw err;
      }
    },
    removeMeter: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const data = await Meter.removeMeter({ id: payload.id });
        // dispatch("getMeterByArea", { areaId: data?.area?.objectId });
        return data;
      } catch (err) {
        throw err;
      }
    },
    getMeterDigitalByMarkets: async ({ commit }, marketIds) => {
      try {
        const data = await Meter.getMeterDigitalByMarkets(marketIds);
        commit("setMeters", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getMeterByIds: async ({ commit }, marketIds) => {
      try {
        const data = await Meter.getMeterByIds(marketIds);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getMeter: async ({ commit }, id) => {
      try {
        const data = await Meter.getMeter(id);
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    getMeterIds: state => state.meterSettings.map(i => i.objectId),
    getMeterSettings: state => {
      const newObj = [...state.meterSettings];
      const newObjFilter = newObj.filter(i => {
        if (i.area) return i;
      });
      return newObjFilter;
    },
    getMeter: state => {
      const meter = state.meter.map(item => {
        item.label = item.name
          ? item.name
          : `(${item.isMain ? "หลัก" : "เสริม"})  มิเตอร์${
              item.type == "elec" ? "ไฟฟ้า" : "น้ำ"
            }`;
        return item;
      });
      return meter;
    },
    getMetersWater: state => {
      return state.meter.filter(d => d.type == "water");
    },
    getMetersElec: state => {
      return state.meter.filter(d => d.type == "elec");
    }
  },
  mutations: {
    setMeter: (state, payload) => {
      state.meter = payload.meter;
    },
    setMeters: (state, meters) => {
      state.meters = meters
    },
    setMeterSetting: (state, payload) => {
      state.meterSettings = payload.meter;
    }
  }
};
export default MeterModule;
